<template>
    <div>
        <p class="h4">Location</p>
        <p>{{event.address_address}}</p>
        <gmap-map
                :center="{ lat: event.address_lat, lng: event.address_lng }"
                :zoom="12"
                ref="map">
            <gmap-marker :position="{ lat: event.address_lat, lng: event.address_lng }"></gmap-marker>
        </gmap-map>
    </div>

</template>

<script>
    export default {
        name: "LocationBlock",
        props: ['event']
    }
</script>

<style scoped>

</style>